import { createContext } from "react";

/**
 * All possible authentication states.
 */
export const enum AuthenticationStatus {
  /**
   * The user is logged in, meaning GraphQL returned a current user.
   */
  LOGGED_IN = "LOGGED_IN",
  /**
   * The user is logged out, meaning GraphQL DID NOT return a current user
   * or there was a GraphQL error.
   */
  LOGGED_OUT = "LOGGED_OUT",
  /**
   * The GraphQL request is still loading.
   */
  LOADING = "LOADING",
}

/**
 * Provide information about the authentication state of the user.
 */
export interface AuthProviderState {
  /**
   * Whether the user is authenticated or not.
   */
  authenticationStatus: AuthenticationStatus;
}

const initialState: AuthProviderState = {
  authenticationStatus: AuthenticationStatus.LOADING,
};

/**
 * See AuthProviderState.
 */
export const AuthProviderContext =
  createContext<AuthProviderState>(initialState);
